mutation PromoteQueueJobMutation($queueName: String!, $id: ID!) {
  promoteQueueJob(queueName: $queueName, id: $id) {
    id
    state
    progress
    attemptsMade
    failedReason
    finishedOn
    processedOn
  }
}
